import {
  TOGGLE_DIGITAL_SIGNATURE_DIALOG,
  TOGGLE_BILLING_PAYMENT_DIALOG,
  TOGGLE_SEND_BILLING_DIALOG,
  TOGGLE_CLICK_CONFIRMATION_DIALOG,
  TOGGLE_FLAGGING_DIALOG,
  TOGGLE_CREATE_SOLO_DIALOG,
  TOGGLE_CLIENT_INVOICE_LOGS_DIALOG,
  TOGGLE_ADD_SOLO_POSITION_DIALOG,
  TOGGLE_ADD_DISCOUNT_DIALOG,
  TOGGLE_MANAGE_EXPENSES_DIALOG,
  TOGGLE_PAY_NOW_DIALOG,
  TOGGLE_VIEW_TRANSFERS_DIALOG,
  TOGGLE_BILLING_ADJUSTMENT_DIALOG,
  TOGGLE_SOLO_REPRESENTATIVE_DIALOG,
} from "../actions/billingDialogs"

const billingDialogsInitialState = {
  digitalSignatureDialogOpen: false,
  billingPaymentDialogOpen: false,
  sendBillingDialogOpen: false,
  clickConfirmationDialogOpen: false,
  flaggingDialogOpen: false,
  createSoloDialogOpen: false,
  addSoloPositionDialogOpen: false,
  addDiscountDialogOpen: false,
  manageExpensesDialogOpen: false,
  payNowDialogOpen: false,
  viewTransfersDialogOpen: false,
  billingAdjustmentDialogOpen: false,
  soloRepDialogOpen: false,
  ClientInvoiceLogsDialogOpen: false,
  data: {},
}

export default (state = billingDialogsInitialState, action) => {
  switch (action.type) {
    case TOGGLE_ADD_DISCOUNT_DIALOG:
      return {
        ...state,
        addDiscountDialogOpen: action.addDiscountDialogOpen,
        data: action.data,
      }
    case TOGGLE_DIGITAL_SIGNATURE_DIALOG:
      return {
        ...state,
        digitalSignatureDialogOpen: action.digitalSignatureDialogOpen,
        data: action.data,
      }
    case TOGGLE_BILLING_PAYMENT_DIALOG:
      return {
        ...state,
        billingPaymentDialogOpen: action.billingPaymentDialogOpen,
        data: action.data,
      }
    case TOGGLE_FLAGGING_DIALOG:
      return {
        ...state,
        flaggingDialogOpen: action.flaggingDialogOpen,
        data: action.data,
      }
    case TOGGLE_SEND_BILLING_DIALOG:
      return {
        ...state,
        sendBillingDialogOpen: action.sendBillingDialogOpen,
        data: action.data,
      }
    case TOGGLE_CLICK_CONFIRMATION_DIALOG:
      return {
        ...state,
        clickConfirmationDialogOpen: action.clickConfirmationDialogOpen,
        data: action.data,
      }
    case TOGGLE_CREATE_SOLO_DIALOG:
      return {
        ...state,
        createSoloDialogOpen: action.createSoloDialogOpen,
        data: action.data,
      }
    case TOGGLE_ADD_SOLO_POSITION_DIALOG:
      return {
        ...state,
        addSoloPositionDialogOpen: action.addSoloPositionDialogOpen,
        data: action.data,
      }
    case TOGGLE_MANAGE_EXPENSES_DIALOG:
      return {
        ...state,
        manageExpensesDialogOpen: action.manageExpensesDialogOpen,
        data: action.data,
      }
    case TOGGLE_PAY_NOW_DIALOG:
      return {
        ...state,
        payNowDialogOpen: action.payNowDialogOpen,
        data: action.data,
      }
    case TOGGLE_VIEW_TRANSFERS_DIALOG:
      return {
        ...state,
        viewTransfersDialogOpen: action.viewTransfersDialogOpen,
        data: action.data,
      }
    case TOGGLE_BILLING_ADJUSTMENT_DIALOG:
      return {
        ...state,
        billingAdjustmentDialogOpen: action.billingAdjustmentDialogOpen,
        data: action.data,
      }
    case TOGGLE_SOLO_REPRESENTATIVE_DIALOG:
      return {
        ...state,
        soloRepDialogOpen: action.soloRepDialogOpen,
        data: action.data,
      }
    case TOGGLE_CLIENT_INVOICE_LOGS_DIALOG:
      return {
        ...state,
        ClientInvoiceLogsDialogOpen: action.ClientInvoiceLogsDialogOpen,
        data: action.data,
      }
    default:
      return state
  }
}
